export class PickerConfig {
  groups: { label: string, options: { value: string; label: string, returnObject?: any }[] }[];
  options: { value: string; label: string }[];

  constructor() {
  }
}
